module.exports = __webpack_public_path__ + "media/operational-monitoring_en_ipad_air.8aa4cb28.mp4";